function navigatorValue(key, fallback) {
  return typeof navigator !== "undefined" ? navigator[key] : fallback;
}

/** Pages that remount native date/time inputs and black-screen on iOS WebKit. */
export const IOS_PICKER_KEEP_ALIVE_PAGES = ["coupleMatch", "settings", "wedding", "western"];

const NATIVE_PICKER_TYPES = new Set(["date", "datetime-local", "time"]);

export function pickerKeepAlivePage(page) {
  return IOS_PICKER_KEEP_ALIVE_PAGES.includes(page) ? page : null;
}

/** Inactive slots must not host a real date/time control. iOS paints those as a fullscreen black layer. */
export function suspendedNativePickerType(type, suspended) {
  const resolved = type || "text";
  if (suspended && NATIVE_PICKER_TYPES.has(resolved)) return "text";
  return resolved;
}

/**
 * Hiding a live date/time input in the same frame another date/time page is shown
 * leaves a black compositor layer (Western ↔ Settings). On iOS, paint the outgoing
 * controls as plain text first (`demoted`), then swap the visible slot.
 */
export function nextPickerSlotState(state, nextPage, ios) {
  const next = pickerKeepAlivePage(nextPage);
  if (!ios) return { revealed: next, demoted: null, waitForPaint: false };
  if (state.revealed === next && !state.demoted) return { revealed: state.revealed, demoted: null, waitForPaint: false };
  if (state.revealed && state.revealed !== next && state.demoted !== state.revealed) {
    return { revealed: state.revealed, demoted: state.revealed, waitForPaint: false };
  }
  return { revealed: next, demoted: null, waitForPaint: true };
}

export function isIosWebkit(
  userAgent = navigatorValue("userAgent", ""),
  maxTouchPoints = navigatorValue("maxTouchPoints", 0),
  platform = navigatorValue("platform", "")
) {
  const ua = String(userAgent || "");
  if (/iP(hone|od|ad)/.test(ua)) return true;
  return platform === "MacIntel" && Number(maxTouchPoints) > 1;
}

export function recoverIosScrollLayer(el) {
  if (!el || !isIosWebkit()) return;
  const top = el.scrollTop;
  el.style.transform = "translateZ(0)";
  void el.offsetHeight;
  el.style.transform = "";
  el.scrollTop = top;
}
